<template>
  <div>
    <div class="contents">
      <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
        <span class="fa-stack fa-2x logo">
          <i class="fa fa-circle fa-stack-2x"></i>
          <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
        </span>
        <div class="title">
          <div class="meta">設定</div>
          {{ title }}
        </div>
      </el-card>

      <div class="table-block">
        <div v-if="toolbar" class="header">
          <div class="left tenants" v-if="visibleTenantsSelect">
            <el-select
              placeholder="テナントを選択"
              v-model="tenantId"
              filterable
              @change="onClickSearchButton"
              :clearable="true"
              :disabled="table.loading"
            >
              <el-option
                v-for="t in $store.getters.tenants.data"
                :key="t.name"
                :label="t.name"
                :value="t.uuid"
              ></el-option>
            </el-select>
          </div>
          <div class="left">
            <el-input
              v-if="visibleSearch"
              placeholder="検索 ... "
              v-model="search"
              class="input-search"
              @keyup.enter.native="onClickSearchButton"
              :clearable="true"
              @clear="onClickSearchButton"
            >
              <el-button
                slot="append"
                type="primary"
                icon="el-icon-search"
                @click="onClickSearchButton"
              ></el-button>
            </el-input>
          </div>
          <div class="right">
            <el-button-group>
              <el-button icon="el-icon-plus" type="primary" @click="onClickNewButton">新規</el-button>
              <el-button
                v-if="visibleBulkUpdate"
                type="warning"
                icon="el-icon-more"
                @click="onClickBulkUpdateButton"
                :disabled="!rowSelected"
              >一括更新</el-button>
              <el-button
                icon="el-icon-delete"
                type="danger"
                @click="onClickDeleteButton"
                :disabled="!rowSelected"
              >削除</el-button>
            </el-button-group>
            <slot name="additional-buttons"></slot>
            <el-dropdown v-show="canExportImport">
              <el-button class="dropdown-button">
                <i class="fa fa-cog fa-lg"></i>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item disabled>エクスポート</el-dropdown-item>
                <el-dropdown-item disabled>インポート</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="body">
          <el-table
            :data="table.data"
            v-loading="table.loading"
            style="width: 100%"
            :default-sort="tableSort"
            @selection-change="handleSelectionChange"
          >
            <slot name="table-columns"></slot>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AdminEventBus } from "@/components/admin/EventBus";

export default {
  props: {
    title: String,
    endpointUrl: String,
    toolbar: {
      type: Boolean,
      default: true
    },
    visibleTenantsSelect: {
      type: Boolean,
      default: true
    },
    visibleBulkUpdate: {
      type: Boolean,
      default: false
    },
    visibleSearch: {
      type: Boolean,
      default: true
    },
    tableSort: Object,
    fetchDataCallback: {
      type: Function,
      default: function(next) {
        next();
      }
    }
  },
  data() {
    return {
      table: {
        data: [],
        loading: false,
        selection: []
      },
      search: "",
      canExportImport: false,
      tenants: {
        names: [],
        dict: {},
        data: {}
      },
      tenantId: ""
    };
  },
  computed: {
    rowSelected: function() {
      if (this.toolbar) {
        return this.table.selection.length !== 0;
      }
      return false;
    },
    selectedIDList: function() {
      if (this.table.selection.length > 0) {
        return this.table.selection.map(item => {
          return "uuid" in item ? item.uuid : item.id;
        });
      }
      return [];
    }
  },
  created() {
    this.fetch();
    AdminEventBus.$on("refresh", () => {
      this.fetchData();
    });
  },
  watch: {
    $route: "fetch"
  },
  methods: {
    onClickNewButton: function() {
      AdminEventBus.$emit("click-new");
    },
    onClickDeleteButton: function() {
      AdminEventBus.$emit("click-delete", this.selectedIDList);
    },
    onClickBulkUpdateButton: function() {
      AdminEventBus.$emit("click-bulkUpdate", this.selectedIDList);
    },
    onClickSearchButton: function() {
      this.table.loading = true;
      this.$router.push({
        name: this.$route.name,
        query: { search: this.search, tid: this.tenantId }
      });
    },
    fetch() {
      this.fetchData();
      if (this.visibleTenantsSelect) {
        this.fetchTenants();
      }
    },
    fetchTenants() {
      this.$store.dispatch("updateTenants", this.$route.query.tid).then(() => {
        this.tenantId = this.$route.query.tid;
      });
    },
    fetchData() {
      this.table.loading = true;
      let url = this.endpointUrl;
      let params = {};
      if (
        this.$route.query.search !== undefined &&
        this.$route.query.search !== ""
      ) {
        this.search = this.$route.query.search;
        params["search"] = this.$route.query.search;
      }
      if (this.$route.query.tid !== undefined && this.$route.query.tid !== "") {
        params["tid"] = this.$route.query.tid;
      }
      if (this.$route.query.page !== undefined && this.$route.query.page > 0) {
        params["page"] = this.$route.query.page;
      }
      axios
        .get(url, { params: params })
        .then(response => {
          this.fetchDataCallback(() => {
            this.table.data = response.data;
            this.table.loading = false;
          });
        })
        .catch(error => {
          console.log(error);
          this.table.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.table.selection = val;
    }
  }
};
</script>

<style scoped>
/* title */
.logo {
  color: #012c63;
}

.title {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  font-weight: bold;
  margin-left: 12px;
}
.meta {
  color: #666;
  font-size: 14px;
  font-weight: normal;
}

/* table-block */
.table-block {
  margin-top: 16px;
}

.header {
  display: -webkit-flex;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
  align-items: center; /* 縦中央 */
  justify-content: center; /* 縦中央 */
  background-color: #fafafa;
  border: 1px solid #e6e6e6;
}

.header .left {
  -webkit-flex: 1;
  flex: 1;
}

.header .tenants {
  flex: 0 1 20%;
  margin-right: 12px;
}
.tenants >>> .el-select {
  width: 100% !important;
}
.tenants >>> .el-select__tags {
  max-width: 100% !important;
}

.header .right {
  width: 300px;
  text-align: right;
}

.header,
.body {
  padding: 8px;
}

.right .el-button {
  padding: 8px 14px;
}

.dropdown-button {
  margin-left: 16px;
}

.dropdown-button .big {
  font-size: 18px;
}

.input-search >>> .el-button {
  border-color: transparent;
  border-radius: 0 2px;
}

.input-search >>> .el-button:hover {
  background-color: #dcdfe6;
}
</style>
